import React from "react";
import { Link } from "react-router-dom";

/**
 * Explains MossMatrix herb-only gel blends (no fresh fruit in the jar).
 */
export default function WhyHerbBasedNote({ compact = false }) {
  if (compact) {
    return (
      <p className="text-xs text-botanical/70 leading-relaxed max-w-xl">
        We keep made-to-order blends <strong className="text-forest font-medium">herb-based</strong> for freshness and safer UK delivery. Fruit
        can be mixed in at home, but our shipped custom blends stay botanical. Add finished gel to shakes, oats, yoghurt, coconut water, juice,
        or warm drinks at home.{" "}
        <Link to="/learn/how-to-use-sea-moss-gel" className="underline hover:text-forest">
          How to use
        </Link>
      </p>
    );
  }
  return (
    <section className="rounded-2xl border border-gold/25 bg-cream/40 px-6 py-5 max-w-2xl">
      <h3 className="font-serif text-lg text-forest">Why we keep our blends herb-based</h3>
      <p className="mt-2 text-sm text-botanical/85 leading-relaxed">
        Fresh fruit can shorten shelf life, ferment inside gel, build pressure during delivery, or even stress packaging. Herb, root, spice, and
        pantry-stable botanical powders travel more predictably. Add your finished gel to shakes, oats, yoghurt, coconut water, juice, warm
        drinks, or simple recipes at home.
      </p>
    </section>
  );
}
